define('ShowFacetsExtraValues.View', [
    'Backbone',
    'jQuery',
    'underscore',
    'show_facets_extra_value.tpl'
], function View(
    Backbone,
    jQuery,
    _,
    ViewTpl
) {
    'use strict';

    return Backbone.View.extend({

        template: ViewTpl,

        initialize: function initialize(options) {
            this.extraValues = options.extraValues;
            this.showModel = options.showModel;
            this.showModel.on('change:show', _.bind(this.render, this));
        },

        getContext: function getContext() {
            return {
                show: this.showModel.get('show'),
                extraValues: this.extraValues
            };
        }
    });
});
